import { render, staticRenderFns } from "./ObservatoryIcon.vue?vue&type=template&id=9d648dd8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d648dd8')) {
      api.createRecord('9d648dd8', component.options)
    } else {
      api.reload('9d648dd8', component.options)
    }
    module.hot.accept("./ObservatoryIcon.vue?vue&type=template&id=9d648dd8&", function () {
      api.rerender('9d648dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/ObservatoryIcon.vue"
export default component.exports